import { useQuery } from "@tanstack/react-query"
import dayjs from "dayjs"

import { getScheduledMessages } from "./api"
import useCurrentClient from "../../pages/clients/hooks/useCurrentClient"
import useRoutinesStore from "../../pages/clients/routines/useRoutinesStore"
import { QueryKey } from "../../types/queries"

export const useScheduledMessagesQuery = () => {
  const { currentCoachingGroup } = useCurrentClient()
  const { currentClientProfile } = useCurrentClient()
  const { startDate } = useRoutinesStore()

  return useQuery({
    queryKey: [
      QueryKey.SCHEDULED_MESSAGES,
      currentCoachingGroup?.id,
      startDate,
    ],
    queryFn: () =>
      getScheduledMessages({
        groupId: currentCoachingGroup?.id!,
        minDatetime: dayjs(startDate).startOf("day").toISOString(),
      }),
    select: (data) =>
      data.map((message) => {
        const clientTimezone = currentClientProfile?.user.timezone!

        return {
          ...message,
          datetime: dayjs(message.datetime).tz(clientTimezone).format(), // convert utc to client timezone
        }
      }),
    enabled:
      !!currentCoachingGroup?.id &&
      !!startDate &&
      !!currentClientProfile?.user.timezone,
  })
}
